export const Empty = Symbol('Empty');

export function validate(value, fieldName) {
  if (value === Empty) {
    logger.debug(
      `Attempted to access property '${fieldName}' but it has not been populated by Mandark. Check your includes.`
    );
  }
}
